<!--
 * @Author: Merlin
 * @Date: 2024-01-16 09:53:32
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-19 16:09:36
 * @Description: 
-->
<template>
    <figure
        class='one-card'
        :style="{ '--width': width, }"
        :class="{ }"
    >
        <div v-if="real" class="card-inner"
            :class="{ 'face-up': isFaceUp }"
            ref="cardInnerRef"
        >
            <div v-if="card?.rank" class='front'>
                <span class="number" >
                    {{ card?.rank }} 
                </span>
                <IconSvgUse
                    v-if="card?.suit"
                    fileName="hilo"
                    size="57%"
                    _width="57%"
                    _height="57%"
                    :use="`hilo-${card?.suit}`"
                > </IconSvgUse>
            </div>
            
            <div class="back">
                <img src="../img/card-back.webp" alt="反面" />
            </div>
            <div ref="borderRef" class="electric-border"></div>
        </div>
    </figure>
</template>

<script setup lang="ts">
import { a4suits } from '~/pages/casino/zhajinhuaGame/ts/cardsConstant';
import { playHighlightEffect as playHighlightEffectFn } from '../ts/animation';

const props = withDefaults(defineProps<{
    width?: string,
    cardName?: string, // 入参示例： （与后端的牌面表示法一致）  'spades2', 'hearts2', 'diamonds2', 'clubs2', 'spades3', 
    real?: boolean
}>(), {
    width: '30px',
    cardName: ''
})
const cardInnerRef = ref<HTMLElement | null>(null);
const borderRef = ref()
const isFaceUp = computed(() => !!props.cardName); 

const card = computed(() => parseCard(props.cardName));

const color = computed(() => {
    const beRed = props.cardName.match(/hearts|diamonds/i); 
    const sColor = beRed ? '#f04051' : '#26292f';
    return sColor;
});

function parseCard(str) {
    for (const suit of a4suits) {
        if (str?.startsWith?.(suit)) {
            return {
                suit: suit.slice(0, -1), // 去掉最后的 "s" 变单数
                rank: str.slice(suit.length),
            };
        }
    }
    return null;
}

// =============================
// 对外暴露：亮牌动效触发
// =============================
const playHighlightEffect = async () => {
    playHighlightEffectFn(borderRef.value);
};


// 暴露给父组件
defineExpose({ playHighlightEffect });
</script>

<style scoped lang="scss">

.one-card{
    width: var(--width);
    height: calc(var(--width) * 1.334);
    font-size: calc(var(--width) * 0.45); // 控制数字的字号 
    perspective: 1000px;
    display: inline-flex; 
    flex-direction: column;
    align-items: center;
}


.card-inner {
    width: 100%;
    height: 100%;
    // width: var(--width);
    // height: calc(var(--width) * 1.34);
    position: relative;
    transform-style: preserve-3d;
    transition: transform 0.3s linear; 
    transform: rotateY(180deg);
    // filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.5));
    // box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5); 
    &.face-up {
        transform: rotateY(0deg);
    }
}

.electric-border {
    pointer-events: none;
    position: absolute;
    width: 100%;
    height: 100%;
    filter: drop-shadow(0 0 14px rgba(0, 210, 255, 0.9));
    outline: 2px solid rgba(0, 210, 255, 0.8);
    outline-offset: 0px;
    border-radius: 4px;
    opacity: 0;
    transition: opacity .2s;
}

.front,
.back {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    border-radius: 4px;
    overflow: hidden;
    filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.5));
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center; 
    }
}


.front{
    background-color: white;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    .number{
        color: v-bind('color');
        font-weight: bold;
        line-height: 1;
        align-self: flex-start;
        margin: 2px 0 0px calc(var(--width) * 0.15);  
    }
    & > svg{
        align-self: flex-end;
        margin: 0 auto 0; 
    }
}

.back {
    transform: rotateY(180deg);
    display: flex;
    justify-content: center; 
    align-items: center; 
    background-color: white; 
}


</style>

